export default "__VITE_ASSET__B6wy_zdb__"